import { Component } from '@angular/core';
import { UIIconComponent } from '@design-system';

@Component({
	selector: 'app-not-found',
	templateUrl: './not-found.component.html',
	imports: [UIIconComponent]
})
export class NotFoundComponent {}
